import { render, staticRenderFns } from "./FollowUpDownload.vue?vue&type=template&id=4d7bfb53&scoped=true"
import script from "./FollowUpDownload.vue?vue&type=script&lang=js"
export * from "./FollowUpDownload.vue?vue&type=script&lang=js"
import style0 from "./FollowUpDownload.vue?vue&type=style&index=0&id=4d7bfb53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7bfb53",
  null
  
)

export default component.exports